import React from "react";
import { useNavigate } from 'react-router-dom'; // Add this import
import "./ClientsWeServe.css";
import Navbar from "../comp/Navbar";
import Footer from "../comp/Footer";
import serviceIcon from "../assets/services.jpg"
import ScrollToTop from "../comp/ScrollToTop";

const ClientsWeServe = () => {
  const navigate = useNavigate(); // Add this hook

  return (
    <>
      <Navbar />
      <div className="clients-we-serve">
        <div style={{
          position: 'relative',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: "3em",
          marginBottom: "3em"
        }}>
          <h3
            style={{ margin: 0 }}
            data-aos="fade"
            data-aos-duration="700"
            data-aos-once="True"
            data-aos-delay="50"
          >
            <b>Clients We Serve</b>
          </h3>

          {/* Navigation Button - positioned on the right */}
          <button
            onClick={() => navigate("/aboutus/team")}
            className="responsive-button"
            style={{
              position: 'absolute',
              right: 0,
              backgroundColor: "#34a853",
              color: "white",
              border: "none",
              padding: "8px 14px",
              fontSize: "14px",
              fontWeight: "bold",
              borderRadius: "5px",
              cursor: "pointer",
              transition: "all 0.3s ease",
              fontFamily: "Merriweather sans",
              textTransform: "uppercase",
              minWidth: "100px",
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "#2d8a45";
              e.target.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "#34a853";
              e.target.style.transform = "translateY(0)";
            }}
          >
            Team
          </button>
        </div>

        {/* First row of clients */}
        <div className="clients-row">
          <div className="clients-card">
            <b>CPA firms</b>
          </div>
          <div className="divider" />
          <div className="clients-card">
            <b>Accounting firms</b>
          </div>
          <div className="divider" />
          <div className="clients-card">
            <b>Startups</b>
          </div>
        </div>

        <div className="clients-row">
          <div className="clients-card">
            <b>Non-profit organizations</b>
          </div>
          <div className="divider" />
          <div className="clients-card">
            <b>Growing businesses</b>
          </div>
        </div>

        {/* Second row of clients */}
        <div className="clients-row">
          <div className="clients-card clients-card-list-container">
            <b>Professional services firms</b>
            <ul className="clients-card-list">
              <li>Valuation services firms</li>
              <li>Forensic expert service firms</li>
              <li>Dispute resolution firms</li>
              <li>Consulting firms</li>
            </ul>
          </div>
          <div className="divider" />
          <div className="clients-card clients-card-list-container">
            <b>Private capital funds</b>
            <ul className="clients-card-list">
              <li>PE, VC, Independent Sponsors, Search Funds, etc.</li>
              <li>Real estate funds</li>
            </ul>
          </div>
        </div>



      </div>
      <section className="cutimage">
        <div className="cutimage_au">
          <div className="emptybg1"></div>
          <span className="imagestyle1">
            <span className="insidespan">
              <img
                alt="cut-pic"
                src={serviceIcon}
                decoding="sync"
                style={{
                  display: "block",
                  maxWidth: "100%",
                  width: "initial",
                  height: "initial",
                  background: "none",
                  opacity: "1",
                  border: "0px",
                  margin: "0px",
                  padding: "0px",
                }}
              />
            </span>
            <img
              alt="city"
              className="imagejpg"
              decoding="async"
              src={serviceIcon}
            />
          </span>
        </div>
      </section>
      <Footer />
      <ScrollToTop />
    </>
  );
};

export default ClientsWeServe;